<script setup></script>
<template>
  <div class="contentHeading">
    <h2><slot name="title"></slot></h2>
    <div class="actions">
      <slot name="actions"></slot>
    </div>
  </div>
</template>
<style scoped>
.contentHeading {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #ccc;
  margin-bottom: 20px;
  padding: 10px 0;
  height: 49px;
}

.contentHeading h2 {
  position: relative;
  padding-left: 25px;
  background: url(/src/assets/images/common/conTit2.png) no-repeat left -2px;
  font-size: 19px;
  line-height: 1.2;
  letter-spacing: -2px;
}

.actions {
  display: flex;
  gap: 0.5rem;
}

.actions :deep(.button) {
  margin: 0;
}

</style>

